export const GET_ALL_NOTICES_SUCCESS = 'GET_ALL_NOTICES_SUCCESS';
export const GET_ALL_NOTICES_FAILED = 'GET_ALL_NOTICES_FAILED';
export const GET_ALL_REQUEST = 'GET_ALL_REQUEST';
export const GET_ALL_NOTICES_UNREAD_LENGTH = 'GET_ALL_NOTICES_UNREAD_LENGTH';
